module.exports = __webpack_public_path__ + "static/img/sec3-icons@tw.b30afd3.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/ezwel-renewal/sec3-icons@tw.png
// module id = /5y3
// module chunks = 0